import { useTranslation } from "react-i18next"

import { useDispatch, useSelector } from "react-redux"
import { useEffect } from "react"
import { selectShipmentBoxes, selectUpdatingDocsWeightError, selectUpdatingDocsWeightStatus, uploadShipmentBoxes } from "../shipmentItemsSlice"
import DocsItem from "./DocsItem"
import { selectShipment, uploadShipmentDeliveryPrices } from "../../shipmentSlice"
import { pushAlert } from "../../../alerts/alertSlice"
const Docs = () => {
    const dispatch = useDispatch()
    const shipment = useSelector(selectShipment)
    const shipmentBoxes = useSelector(selectShipmentBoxes)
    const error = useSelector(selectUpdatingDocsWeightError)
    const status = useSelector(selectUpdatingDocsWeightStatus)
    
    const {t} = useTranslation()

    useEffect(() => {
        if(shipment.id !== null && shipment.id !== undefined)
        {
            dispatch(uploadShipmentBoxes({shipmentID: shipment.id}))
        }
    }, [dispatch, shipment.id])

    useEffect(() => {
        if(error) {
            dispatch(pushAlert({
                message: t(error),
                type: "danger"
            }))
        }
    }, [dispatch, error])

    useEffect(() => {
        if(status === "fulfilled" && shipment?.id) {
            dispatch(uploadShipmentDeliveryPrices({ shipmentID: shipment.id }));
        }
    }, [dispatch, shipment.id, status])


    if(shipment["bill-id"]) return <></>;

    return (
      <div>
        <header className="text-xl text-center text-emerald-600 font-bold mb-4">
            {t("shipment.docs.title")}
        </header>
        <main 
            style={{
                maxWidth: "500px",
                margin: "0 auto",
                display: "block"
            }}
        >
            {
                shipmentBoxes?.map((box) => 
                    <DocsItem initialWeight={box.weight} shipmentID={box["shipment-id"]} />
                )
            }
        </main>
      </div>
  )
}

export default Docs